var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"killfeed-item",class:{ future: _vm.future }},[_c('div',{staticClass:"timestamp"},[_vm._v(" "+_vm._s(_vm.displayedTime)+" ")]),_c('div',{staticClass:"content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }